import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallBaseCommand } from "~app/features/planera/commands/ProduktionsmallBaseCommand";

export class DeleteProduktionsmallCascadeCommand extends ProduktionsmallBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteProduktionsmallCascadeCommand";

    constructor(guid: string) {
        super(DeleteProduktionsmallCascadeCommand.$type, CommandType.Delete);
        this.guid = guid;
    }
}
